import { ModuleRouter } from "@/components/module-router/module-router";

export function FiaRoutes() {
  return <ModuleRouter moduleId="fia" />;
}
